// extracted by mini-css-extract-plugin
export default {"main":"MyLoans_main__C6+bv","cardsRow":"MyLoans_cardsRow__NMuKE","rowTitle":"MyLoans_rowTitle__7384a","body":"MyLoans_body__czZI5"};